import PropTypes from "prop-types";
import * as React from "react";
import { Box, Button, Typography } from "../../themeV2";

export default function AccountChip({ email, onChange }) {
  return (
    <Box direction="row" align="center" justify="space-between" gap={2} wrap>
      <Typography variant="body-md" as="p">
        Signing in as <strong>{email}</strong>
      </Typography>
      <Button variant="text" size="sm" onClick={onChange}>
        Use a different account
      </Button>
    </Box>
  );
}

AccountChip.propTypes = {
  email: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
